<template>
  <div>

    <main role="main">

      <div class="container">


        <div class="row">
          <div class="col-md-12">
            <a class="mt-3 mb-3 d-block" @click="$router.go(-1)">
              <i class="fa fa-chevron-circle-left"></i> {{ $t('text.globals.back') }}
            </a>
          </div>
        </div>

        <div class="row mb-5">

          <div class="col-md-12">

            <h2 class="mb-5">
              <span v-if="mode==='add'">{{ $t('text.cacheInstanceEntry.addCacheInstance') }}</span><span
                v-if="mode==='edit'">{{ $t('text.cacheInstanceEntry.editCacheInstance') }}</span>
            </h2>
            <form class="mb-5 form-condensed">

              <div>

                <!-- ime -->
                <div class="form-group">
                  <label for="name">{{ $t('text.cacheInstanceEntry.name') }}</label>
                  <input type="text" class="form-control" id="name" aria-describedby="name"
                         v-model="cacheInstance.name" name="name"
                         v-validate="'required'"
                         :class="{'is-invalid': errors.has('name')}"
                  >
                  <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}
                  </div>
                </div>

                <!--UUID oznaka-->
                <div class="form-group">
                  <label for="uuid">{{ $t('text.cacheInstanceEntry.uuidLabel') }}</label>

                  <b-input-group>
                    <input type="text" class="form-control mr-0" id="uuid" aria-describedby="uuid"
                           v-model="cacheInstance.uuid" name="uuid"
                           v-validate="'required'"
                           :disabled="mode==='edit'"
                           :class="{'is-invalid': errors.has('uuid')}"
                    >
                    <b-input-group-append v-if="mode==='add'">
                      <b-button if="createUUIDLabelButton1" variant="secondary" class="m-0"
                                @click="generateUiid()">
                        {{ $t('text.cacheInstanceEntry.createUuidlabel') }}
                      </b-button>
                    </b-input-group-append>
                    <div class="invalid-feedback" v-if="errors.has('uuid')">{{
                        errors.first('uuid')
                      }}
                    </div>
                  </b-input-group>

                </div>

                <!--secret -->
                <div class="form-group">
                  <label for="secret">{{ $t('text.cacheInstanceEntry.password') }}</label>
                  <input type="secret" class="form-control" id="secret"
                         aria-describedby="secret"
                         v-model="cacheInstance.secret" name="secret"
                         v-validate="'required'"
                         :class="{'is-invalid': errors.has('secret')}"
                  >
                  <div class="invalid-feedback" v-if="errors.has('secret')">{{
                      errors.first('secret')
                    }}
                  </div>
                </div>


                <!-- address -->
                <!--                                <div class="form-group">-->
                <!--                                    <label for="address">Naslov</label>-->
                <!--                                    <input type="text" class="form-control" id="address" aria-describedby="address"-->
                <!--                                           v-model="cacheInstance.address" name="address"-->
                <!--                                           v-validate="'required'"-->
                <!--                                           :class="{'is-invalid': errors.has('address')}"-->
                <!--                                    >-->
                <!--                                    <div class="invalid-feedback" v-if="errors.has('address')">{{-->
                <!--                                        errors.first('address')-->
                <!--                                        }}-->
                <!--                                    </div>-->
                <!--                                </div>-->

                <div class="row">
                  <div class="col-md-4">

                    <!--lat -->
                    <div class="form-group">
                      <label for="lat">{{ $t('text.cacheInstanceEntry.latitude') }}</label>
                      <input type="number" step="0.0000000000001" class="form-control" id="lat"
                             style="width: max-content"
                             aria-describedby="lat"
                             v-model="cacheInstance.geoLat" name="lat"
                             v-validate="'required'"
                             :class="{'is-invalid': errors.has('lat')}"
                      >
                      <div class="invalid-feedback" v-if="errors.has('lat')">{{
                          errors.first('lat')
                        }}
                      </div>
                    </div>

                    <!--long -->
                    <div class="form-group">
                      <label for="long">{{ $t('text.cacheInstanceEntry.longitude') }}</label>
                      <input type="number" step="0.0000000000001" class="form-control" id="long"
                             aria-describedby="long"
                             v-model="cacheInstance.geoLong" name="long"
                             v-validate="'required'"
                             :class="{'is-invalid': errors.has('long')}"
                      >
                      <div class="invalid-feedback" v-if="errors.has('long')">{{
                          errors.first('long')
                        }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- description -->
                <div class="form-group">
                  <label for="description">{{ $t('text.globals.description') }}</label>
                  <textarea class="form-control" id="description" aria-describedby="description"
                            v-model="cacheInstance.description" name="description"
                            :class="{'is-invalid': errors.has('description')}"
                  ></textarea>
                  <div class="invalid-feedback" v-if="errors.has('description')">{{
                      errors.first('description')
                    }}
                  </div>
                </div>

                <!-- enabled -->
                <div class="form-group mt-4">
                  <label>{{ $t('text.cacheInstanceEntry.instanceStatus') }}</label>

                  <div>
                    <b-button-group>
                      <b-button id="activeInstanceButton1" class="btn"
                                :class="cacheInstance.enabled ? 'enabled' : 'btn-light'"
                                @click="cacheInstance.enabled = true"><i class="fa fa-circle"
                                                                         :class="cacheInstance.enabled ? 'text-success' : 'text-secondary'"></i>
                        {{ $t('text.cacheInstanceEntry.instanceIsActive') }}
                      </b-button>
                      <b-button id="inactiveInstanceButton1" class="btn"
                                :class="!cacheInstance.enabled ? 'enabled' : 'btn-light'"
                                @click="cacheInstance.enabled = false"><i class="fa fa-circle"
                                                                          :class="!cacheInstance.enabled ? 'text-danger' : 'text-secondary'"></i>
                        {{ $t('text.cacheInstanceEntry.instanceIsInactive') }}
                      </b-button>
                    </b-button-group>
                  </div>

                </div>


              </div>

            </form>

            <div class="row">

              <div class="col-md-6 text-left">

                <router-link :to="{ name: 'Status' }" class="btn btn-link pt-4">
                  {{ $t('text.globals.cancel') }}
                </router-link>

              </div>

              <div class="col-md-6 text-right">

                <div v-if="mode==='add'">
                  <button id="addCacheInstanceButton1" type="submit" @click="addCacheInstanceEntry"
                          class="btn btn-primary mt-3 mb-4 right">
                    {{ $t('text.cacheInstanceEntry.addInstance') }}
                  </button>
                </div>
                <div v-if="mode==='edit'">
                  <a class="btn btn-danger mt-3 mb-4 mr-3 text-white ml-1"
                     @click="deleteInstanceConfirmation(cacheInstance.id,cacheInstance.name)"><i
                      class="fa fa-trash"></i> {{ $t('text.globals.delete') }}</a>

                  <button id="saveButton1" type="submit" @click="editCacheInstanceEntry"
                          class="btn btn-success mt-3 mb-4 right">
                    <i class="fa fa-save"></i> {{ $t('text.globals.saveChanges') }}
                  </button>
                </div>

              </div>

            </div>

          </div>
        </div>

      </div>

    </main>

  </div>
</template>

<script type="text/javascript">
import Vue from 'vue';
import {library} from '@fortawesome/fontawesome-svg-core'
import {faHome} from '@fortawesome/free-solid-svg-icons'
import SidebarNavigation from '../components/SidebarNavigation';
import TreeStructure from '../components/TreeStructure';
import iconMarkerGreen from '../assets/images/icon-marker-green.svg'
// import Places from 'places.js';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import axios from 'axios/index';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import uuidv1 from 'uuid/v1';

library.add(faHome);

export default {
  name: 'CacheInstanceEntry',
  components: {
    SidebarNavigation,
    TreeStructure,
    vSelect,
    // Places
    Loading
  },
  data() {
    return {
      zoom: 18,
      center: L.latLng(46.054860, 14.506770),
      url: '//{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution: "",
      classificationPlan: this.$store.getters.getClassificationPlan,
      mode: 'edit',
      selectedClassLabel: null,
      cacheInstance: {
        name: "",
        uuid: "",
        secret: "",
        geoLat: "",
        geoLong: "",
        description: "",
        enabled: false,
        state: ""
      }
    }
  },
  mounted() {
    let _this = this;

    console.log("_this.$root.$i18n.locale", _this.$root.$i18n.locale);

    _this.$validator.localize(_this.$root.$i18n.locale, {
      messages: {
        required: (field) => '* ' + _this.$t('text.validationMessages.field') ? _this.$t('text.validationMessages.field').charAt(0).toUpperCase() + _this.$t('text.validationMessages.field').slice(1) + ' ' + _this.$t('text.validationMessages.required') + '.' : '',
        decimal: (field) => '* ' + _this.$t('text.validationMessages.field') ? _this.$t('text.validationMessages.field').charAt(0).toUpperCase() + _this.$t('text.validationMessages.field').slice(1) + ' ' + _this.$t('text.validationMessages.notValid') + '.' : '',
      }
    });

    console.log(this.$route.params);

    if (typeof _this.$route.params.id !== 'undefined') {
      _this.mode = 'edit';

      this.isLoading = true;

      axios.get(config.alfrescoServiceApi + 'ehramba/nodeSynch/cache-service/' + _this.$route.params.id)
          .then((res) => {

            console.log(res.data);

            _this.cacheInstance = res.data;
            // _this.cacheInstance.geoLat = res.data.geoLat.replace(',','.');
            // _this.cacheInstance.geoLong = res.data.geoLong.replace(',','.');

            this.isLoading = false;


          })
          .catch((error) => {
            console.error(error);

            this.isLoading = false;
          });


    } else {
      this.mode = 'add';

      // TEST server validation (duplicated UUID)
      // _this.cacheInstance = {
      //     description: "test",
      //     enabled: true,
      //     geoLat: "45",
      //     geoLong: "45",
      //     name: "MarkusTest",
      //     secret: "a3d954c0-ea60-11e9-ae10-2bb08070739d",
      //     state: "",
      //     uuid: "a3d954c0-ea60-11e9-ae10-2bb08070739d",
      // }

    }

  },

  computed: {
    generateMarkers() {

      if (this.cacheInstance.geoLat === null || this.cacheInstance.geoLong === null) {
        return []
      }

      console.log(this.cacheInstance.geoLat);
      console.log(this.cacheInstance.geoLong);

      let marker = [];

      marker.push(
          {
            id: this.cacheInstance.id,
            latlng: L.latLng(this.cacheInstance.geoLat, this.cacheInstance.geoLong),
            content: null,
            icon: L.icon({
              iconUrl: iconMarkerGreen,
              iconSize: [38, 38], // size of the icon
              iconAnchor: [16, 38], // point of the icon which will correspond to marker's location
              popupAnchor: [3, -30] // point from which the po
            })
          }
      );

      this.center = L.latLng(this.cacheInstance.geoLat, this.cacheInstance.geoLong);


      return marker;


    }
  },

  methods: {
    addMarkerViaMap(event) {
      console.log("event", event);
      this.cacheInstance.geoLat = event.latlng.lat;
      this.cacheInstance.geoLong = event.latlng.lng;
    },
    addCacheInstanceEntry() {
      const _this = this;
      console.log("add");

      if (!_this.$validator) return

      // validacija polj z knižnjico vee-validate
      this.$validator.validate().then(result => {


        // če je validacija uspešna
        if (result) {
          console.log("validacija uspešna");


          axios.post(config.alfrescoServiceApi + 'ehramba/nodeSynch/cache-service', _this.cacheInstance)
              .then((res) => {

                _this.$router.push({name: 'Status'});
                console.log("response: ", res);

              })
              .catch((error) => {
                console.log(error.response.status);
                // handle server validations
                if (error.response.status === 400 && error.response.data.body.type === "ValidationError") {

                  _this.displayServerErrorsOnFields(error.response.data.body.validationErrors);

                } else {
                  console.error(error);
                }
                this.isLoading = false;
              });


          console.log("data to save: ", this.cacheInstance)
        } else {
          console.log("validacija neuspešna");
        }
      });
    },

    editCacheInstanceEntry() {
      const _this = this;
      console.log("edit");

      if (!_this.$validator) return

      _this.$validator.validate().then(result => {

        // če je validacija uspešna
        if (result) {
          console.log("validacija uspešna");

          axios.put(config.alfrescoServiceApi + 'ehramba/nodeSynch/cache-service', _this.cacheInstance)
              .then((res) => {

                _this.$router.push({name: 'Status'});
                console.log("response: ", res);

              })
              .catch((error) => {
                // handle server validations
                if (error.response.status === 400 && error.response.data.body.type === "ValidationError") {
                  _this.displayServerErrorsOnFields(error.response.data.body.validationErrors);
                } else {
                  console.error(error);
                }
                this.isLoading = false;
              });


          console.log("data to save: ", this.cacheInstance)
        } else {
          console.log("validacija neuspešna");
        }
      });

    },

    deleteInstanceConfirmation(cacheId, cacheName) {
      const _this = this;

      this.$swal({
        title: this.$t('text.globals.warningTitle'),
        text: this.$t('text.cacheInstanceEntry.deleteInstanceConfirmationSwal.content') + ' ' + cacheName + "?",
        dangerMode: true,
        buttons: {
          cancel: {
            text: this.$t('text.globals.cancel'),
            value: null,
            visible: true,
            className: "",
            closeModal: true,
          },
          confirm: {
            text: this.$t('text.globals.delete'),
            value: true,
            visible: true,
            className: "",
            closeModal: true
          }
        },
      })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteInstance(cacheId);

              case null:

                return;

                break;

              default:

            }
          });
    },


    deleteInstance(cacheId) {
      const _this = this;

      axios.delete(config.alfrescoServiceApi + 'ehramba/nodeSynch/cache-service/' + cacheId)
          .then((res) => {

            _this.$router.push({name: 'Status'});
            console.log("response: ", res);

          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });

    },

    generateUiid() {
      this.cacheInstance.uuid = uuidv1();
    },

    displayServerErrorsOnFields(validationErrors) {
      const _this = this;

      if (!validationErrors) {
        return
      }

      _.forOwn(validationErrors, function (value, key) {
        let fieldName = key;

        _.each(value, function (validationValue) {
          // manually push error to vee validate errors array
          _this.errors.items.push({
            id: uuidv1().toString(),
            vmId: _this.errors.vmId,
            field: fieldName,
            msg: validationValue, // TODO: add localised message
            rule: "required",
            scope: null
          });
        });

      });

    }


  }
};
</script>



// WEBPACK FOOTER //
// src/pages/CacheInstanceEntry.vue